var Myjockey = require('@souche-f2e/myjockey');
// var semver = require('semver');

var is = require('../../sc-is/is-c');
var url_util = require('../../url_util/url_util');
var location_obj = url_util.getLocation();

var sharerecordapi = require('../../share-service/sharerecordapi');

var is_dafengche = is.dafengche();
var is_cheniu = is.cheniu();
var debug__dafengche = is.debug__dafengche();
var debug__cheniu = is.debug__cheniu();
var GLOBAL_CONFIG = {};

function main(callback) {
    var $content_ad = $('.content-ad');
    // 按照微信分享的字段命名
    var title = $("title").text();
    var desc = $content_ad.length? $content_ad.text(): ' ';
    var link = window.location.href;
    var imgUrl = 'http:' + $("img").eq(0).attr('src');

    Myjockey.getData().then(function (data) {
        /**
         * 返回 Promise false
         * @Author   Bolt
         * @DateTime 2016-10-13T15:59:02+0800
         * @param    {Boolean}                is_cheniu ||            debug__cheniu [description]
         * @return   {[type]}                           [description]
         */
        if (is_cheniu || debug__cheniu) {
            /**
             * 覆盖 desc
             * @type {[type]}
             */
            desc = $('.description').text() || desc;
            /**
             * 覆盖 link
             */
            link = location_obj
                .s('salerphone', data.__cheniu.user.userId)
                .toString();
            return false;
        } else if (is_dafengche || debug__dafengche) {
            var link_dafengche_obj = location_obj
                .s('app_type', null)
                .s('no_app_type', 'yes')
                .s('salerphone', $.cookie('salerphone'));
            // 获取 shareId
            return sharerecordapi.getWeiDianShareLinkOnce(data.token, {
                title: title,
                shareLink: link_dafengche_obj.toString(),
                iconLink: imgUrl
            }).then(function (data) {
                link = data;
                return false;
            });
        }
    }).then(function (data) {
        callback({
            title: (GLOBAL_CONFIG.carId || GLOBAL_CONFIG.scene) ? undefined : (GLOBAL_CONFIG.title || title),
            content: GLOBAL_CONFIG.desc || desc,
            url: GLOBAL_CONFIG.link || link,
            image: GLOBAL_CONFIG.imgUrl || imgUrl,
            /**
             * 新增参数
             *     http://fedoc.sqaproxy.souche.com/f2e/common/tower/catalog/api/share/set_share_page_data.html
             */
            scene: GLOBAL_CONFIG.carId? 'C': GLOBAL_CONFIG.scene,
            carNum: GLOBAL_CONFIG.carId? 1: GLOBAL_CONFIG.carNum,
            carSeriseModel: GLOBAL_CONFIG.carSeriseModel,
            carId: GLOBAL_CONFIG.carId,
            platform: 'wd',
            /**
             * 兼容
             *     cheniu
             *         lte v3.2.0
             *     dafengche
             *         lte v5.9.3
             */
            beauty: GLOBAL_CONFIG.carId ? 1 : undefined
        });
    }).fail(function (d, err) {
        console.error(d, err);
    });
}

module.exports = {
    init: function () {
        Myjockey.getData().then(function (data) {
            if (is_dafengche || is_cheniu) {
                window.Jockey.send('ControlWebVCBridge',  {
                    action: 'ShowShare'
                });
                window.Jockey.on('shareBridge', function(payload, complete) {
                    main(complete);
                });
            } else if (debug__dafengche || debug__cheniu) {
                main(function (data) {
                    console.log('Bolt[app]分享数据:', data); 
                });
            }
        });
    },
    config: function (config) {
        GLOBAL_CONFIG = config;
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/lib/share-jockey.js
// module id = 278
// module chunks = 4